import { LayerProps } from 'react-map-gl';

export const PROPERTIES = 'properties';
export const LASSO = 'lasso';

export const clusterLayer: LayerProps = {
  id: 'clusters',
  source: PROPERTIES,
  type: 'circle',
  filter: [ 'has', 'point_count' ],
  paint: {
    'circle-color': [ 'step', [ 'get', 'point_count' ], '#51bbd6', 100, '#f1f075', 750, '#f28cb1' ],
    'circle-radius': [ 'step', [ 'get', 'point_count' ], 20, 100, 30, 750, 40 ]
  }
};

export const clusterCountLayer: LayerProps = {
  id: 'cluster-count',
  source: PROPERTIES,
  type: 'symbol',
  filter: [ 'has', 'point_count' ],
  layout: {
    'text-field': '{point_count_abbreviated}',
    'text-font': [ 'DIN Offc Pro Medium', 'Arial Unicode MS Bold' ],
    'text-size': 12
  }
};
export const clusterLayerPFV: LayerProps = {
  id: 'clusters',
  source: PROPERTIES,
  type: 'circle',
  filter: [
    'all',
    [ 'has', 'point_count' ],
    [ '>=', [ 'get', 'point_count' ], 5 ]
  ],
  paint: {
    'circle-color': [
      'step',
      [ 'get', 'point_count' ],
      // Low density (5–99)
      '#b0cdfb', // '#d3c5fc',
      100,
      // Medium density (100–749)
      '#4e8ef6', // '#A78BFA',
      750,
      // High density (750+)
      '#3b82f6', // '#7C3AED'
    ],

    'circle-radius': [
      'step',
      [ 'get', 'point_count' ],
      20,
      100,
      28,
      750,
      38
    ],

    'circle-stroke-width': 1,
    'circle-stroke-color': '#FFFFFF'
  }
};

export const clusterShadowLayerPFV: LayerProps = {
  id: 'clusters-shadow',
  source: PROPERTIES,
  type: 'circle',
  filter: [
    'all',
    [ 'has', 'point_count' ],
    [ '>=', [ 'get', 'point_count' ], 5 ],
  ],
  paint: {
    'circle-color': '#4C1D95',     // dark REIX purple
    'circle-opacity': 0.25,
    'circle-radius': [
      'step',
      [ 'get', 'point_count' ],
      24,   // a bit larger than main radius
      100,
      30,
      750,
      36,
    ],
    'circle-blur': 0.8,
  },
};

export const clusterCountLayerPFV: LayerProps = {
  id: 'cluster-count',
  source: PROPERTIES,
  type: 'symbol',
  filter: [ 'all', [ 'has', 'point_count' ], [ '>=', [ 'get', 'point_count' ], 5 ] ],
  layout: {
    'text-field': '{point_count_abbreviated}',
    'text-font': [ 'DIN Offc Pro Medium', 'Arial Unicode MS Bold' ],
    'text-size': 12
  }
};

export const lassoLine: LayerProps = {
  id: 'lasso-line',
  source: LASSO,
  type: 'line',
  paint: {
    'line-color': '#4F46E5',
    'line-width': 3
  }
};

export const lassoFill: LayerProps = {
  id: 'lasso-fill',
  source: LASSO,
  type: 'fill',
  paint: {
    'fill-color': '#4F46E5',
    'fill-opacity': 0.2
  }
};
